import { Component } from '@angular/core';
import {
    CityDto,
    CityServiceProxy,
    ClienteUnicoDto,
    ClienteUnicoServiceProxy,
    DomicilioClienteDto,
    StateDto,
    StateServiceProxy,
} from '../services/service-proxy/service-proxies';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, finalize, forkJoin, map, switchMap } from 'rxjs';
import { AppService } from '../services/app.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormControl, Validators } from '@angular/forms';

@Component({
    selector: 'app-customer-form',
    templateUrl: './customer-adress-form.component.html',
    styleUrls: ['./customer-adress-form.component.scss'],
})
export class CustomerAdressFormComponent {
    isLoading = false;

    idUnico;
    domicilioIx: string | null | undefined;

    model: ClienteUnicoDto;
    domicilio: DomicilioClienteDto;

    provinciaControl: FormControl;
    localidadControl: FormControl;

    provincias: StateDto[] | undefined;
    localidades: CityDto[] | undefined;

    isEdit = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private clienteUnicoService: ClienteUnicoServiceProxy,
        private appService: AppService,
        private snackBar: MatSnackBar,
        private stateService: StateServiceProxy,
        private cityService: CityServiceProxy
    ) {
        this.idUnico = appService.idUnico;

        this.model = new ClienteUnicoDto();
        this.domicilio = this.createDomicilioClienteDto();
        this.provinciaControl = new FormControl('', Validators.required);
        this.localidadControl = new FormControl('', Validators.required);
        this.provinciaControl.valueChanges.subscribe((state: StateDto) => {
            this.domicilio.provincia = state.name;
            this.isLoading = true;
            const filters = [`{"key":"stateId","operation":"=","value":"${state.id}"}`];
            this.cityService
                .getAll(filters, 'name asc', 0, 10000)
                .pipe(
                    finalize(() => (this.isLoading = false)),
                    map((x) => x.items)
                )
                .subscribe((cities) => {
                  console.log(this.domicilio);
                    this.localidades = cities;
                    const localidad = this.localidades?.find((x) => x.name?.toUpperCase() === this.domicilio.localidad?.toUpperCase());
                    this.localidadControl.setValue(localidad);
                });
        });

        this.route.paramMap.subscribe((params) => {
            this.domicilioIx = params.get('ix');
        });
    }

    ngOnInit() {
        this.isLoading = true;
        const customerAndStates$ = forkJoin([
            this.clienteUnicoService.get(this.idUnico, null,false),
            this.stateService.getAll(undefined, 'name asc', 0, 100),
        ]);
        customerAndStates$.pipe(finalize(() => (this.isLoading = false))).subscribe((response) => {
            this.model = response[0];
            this.provincias = response[1].items;

            // si es Edit asigno el domicilio al Model
            if (this.domicilioIx) {
                if (this.model?.domicilios) {
                    this.domicilio = this.model.domicilios[Number.parseInt(this.domicilioIx!)];
                    const provincia = this.provincias?.find((x) => x.name?.toUpperCase() === this.domicilio.provincia?.toUpperCase());
                    this.provinciaControl.setValue(provincia);
                    this.isEdit = true;
                }
            }
        });
    }

    /** En Colombia el State es "Departamento" y la City "Municipio". Los datos
     *  vienen bien por el CountryCode que agrega el interceptor; solo cambia la
     *  etiqueta. */
    get esColombia(): boolean {
        return (this.appService.countryCode ?? 'AR').toUpperCase() === 'CO';
    }
    get labelProvincia(): string { return this.esColombia ? 'Departamento' : 'Provincia'; }
    get labelLocalidad(): string { return this.esColombia ? 'Municipio' : 'Localidad'; }

    createDomicilioClienteDto(): DomicilioClienteDto {
        const data = {
            calle: undefined,
            numero: undefined,
            piso: undefined,
            departamento: undefined,
            tipo: undefined,
            codigoPostal: undefined,
            localidad: undefined,
            provincia: undefined,
            pais: undefined,
            origen: undefined,
            status: undefined,
        };

        const domicilio = new DomicilioClienteDto();
        domicilio.init(data);

        return domicilio;
    }

    save() {
        if (!this.isEdit) {
            this.domicilio.status = 1;
            // Antes estaba fijo en 'AR': para un cliente de Colombia guardaba el
            // pais equivocado. Se toma el pais del cliente.
            this.domicilio.pais = this.appService.countryCode ?? 'AR';

            this.model.domicilios?.push(this.domicilio);
        }

        this.model.mascotas = undefined;
        this.isLoading = true;
        this.clienteUnicoService
            .update(this.model)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe((result) => {
                this.snackBar.open('Los cambios se guardaron correctamente.', '', { duration: 2000 });
                this.router.navigateByUrl('/customer-adress-list');
            });
    }
}
